import { c as _c } from "react/compiler-runtime";
import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import styles from './ClubBadge.module.css';
interface ClubBadgeProps {
  readonly children: ReactNode;
  readonly className?: string;
  readonly size?: 'default' | 'compact';
}
export const ClubBadge = t0 => {
  const $ = _c(6);
  const {
    children,
    className,
    size: t1
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const t2 = size === "compact" && styles.compact;
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = clsx(styles.badge, t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== t3) {
    t4 = <span className={t3}>{children}</span>;
    $[3] = children;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};